import { useTranslation } from 'react-i18next'
import type { ScoreLetter } from '@/domains/types'

const GRADES: ScoreLetter[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G']

const GRADE_BG: Record<ScoreLetter, string> = {
  A: '#00703f',
  B: '#88c340',
  C: '#fecb02',
  D: '#ef8200',
  E: '#e63512',
  F: '#c0392b',
  G: '#8b1a1a',
}

interface ScoreGradeSelectorProps {
  value: ScoreLetter | null
  onChange: (grade: ScoreLetter | null) => void
  disabled?: boolean
}

/**
 * Button group A-G + "None" for selecting a validated fact score.
 */
export function ScoreGradeSelector({ value, onChange, disabled = false }: ScoreGradeSelectorProps) {
  const { t } = useTranslation()

  return (
    <div className="flex items-center gap-1 flex-wrap">
      <button
        type="button"
        disabled={disabled}
        onClick={() => onChange(null)}
        className={`px-2 py-1 rounded text-xs font-medium border transition-all ${
          value === null
            ? 'border-foreground bg-muted text-foreground'
            : 'border-border text-muted-foreground hover:border-foreground/40'
        }`}
      >
        {t('lead_detail.fact_score_none')}
      </button>
      {GRADES.map((grade) => (
        <button
          key={grade}
          type="button"
          disabled={disabled}
          onClick={() => onChange(grade)}
          style={
            value === grade
              ? { backgroundColor: GRADE_BG[grade], color: grade === 'C' ? '#333' : '#fff' }
              : {}
          }
          className={`w-8 h-8 rounded font-bold text-sm border transition-all ${
            value === grade
              ? 'border-transparent scale-110 shadow'
              : 'border-border text-muted-foreground hover:border-foreground/40'
          }`}
        >
          {grade}
        </button>
      ))}
    </div>
  )
}
